var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.13,162.7c14.26-14.07,14.34-35.69,10.48-54.45-.65-3.13-.87-6.51-2.84-9s-5.79-3.8-8.38-2c-2.15,1.5-2.71,4.4-3.63,6.87a18.75,18.75,0,0,1-6.18,8.32c-1.83,1.38-4.2,2.44-6.37,1.69-3-1-3.94-4.73-4.45-7.87l-2.88-17.53a29.85,29.85,0,0,0-2.54-9.15c-1.48-2.8-4.11-5.2-7.23-5.52s-6.51,2-6.62,5.19a29,29,0,0,0,.58,3.92c.13,1.32-.23,2.86-1.4,3.43s-2.59-.09-3.69-.85c-3.77-2.61-6.66-6.31-9.4-10s-5.45-7.51-9-10.46-8-5-12.58-4.47-8.83,4.09-9.21,8.69,3,8.65,6.37,11.75A71.25,71.25,0,0,0,78.12,92.63,5.81,5.81,0,0,1,81,94.83c1,2-.58,4.39-2.53,5.42-2.2,1.18-4.77,1.37-7.17,2.08s-4.85,2.23-5.38,4.7c-.74,3.42,2.51,6.32,5.52,8.06a60.68,60.68,0,0,0,19.48,7.21c2.45.45,5,.77,7.13,2.07s3.74,3.93,3,6.33-3.51,3.6-6,3.56-4.88-1-7.32-1.45c-4.59-.89-10.09.36-12.22,4.55a10.06,10.06,0,0,0,.45,8.95A23.12,23.12,0,0,0,82,153.24a61.19,61.19,0,0,0,28.81,13.68c10.57,1.75,20,1.11,29.29-4.22",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.61,64.42a2,2,0,0,0,.35.25l1.07.67c.95.58,2.34,1.45,4.1,2.61A118.33,118.33,0,0,1,78.31,78.82c2.82,2.5,5.81,5.37,9,8.52s6.48,6.53,9.86,10.22a145.86,145.86,0,0,1,10,12.07c1.61,2.19,3.12,4.51,4.65,6.88l4.65,7.2A290.72,290.72,0,0,1,132.76,152a141.56,141.56,0,0,1,9.61,24.81,103.57,103.57,0,0,1,3.32,17.64c.19,2.11.31,3.76.35,4.88,0,.53.05.95.07,1.27a3,3,0,0,0,0,.43,2.06,2.06,0,0,0,0-.43c0-.32,0-.74,0-1.28,0-1.12-.09-2.77-.24-4.89a99.35,99.35,0,0,0-3.15-17.73,139.28,139.28,0,0,0-9.53-24.94,283.83,283.83,0,0,0-16.31-28.32l-4.65-7.2c-1.54-2.36-3.06-4.7-4.69-6.9A138.15,138.15,0,0,0,97.51,97.2C94.12,93.5,90.76,90.12,87.6,87s-6.17-6-9-8.49A114,114,0,0,0,64.26,67.75c-1.79-1.13-3.2-2-4.17-2.51L59,64.62A2.8,2.8,0,0,0,58.61,64.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43,109.29a6.54,6.54,0,0,0,.07-1.38c0-.9,0-2.19,0-3.79-.09-3.19-.36-7.6-.68-12.46s-.54-9.26-.58-12.45c0-1.59,0-2.88,0-3.77a6.37,6.37,0,0,0-.06-1.39,6.31,6.31,0,0,0-.17,1.38c-.08.89-.13,2.18-.16,3.78-.06,3.2.08,7.62.41,12.49s.62,9.12.85,12.44c.1,1.5.17,2.76.24,3.77A5.18,5.18,0,0,0,107.43,109.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.86,108.65a8.79,8.79,0,0,0,1.64-.08c1-.09,2.57-.22,4.45-.32,3.76-.23,9-.37,14.7-.27s10.94.42,14.7.76c1.87.16,3.39.33,4.44.44a8.7,8.7,0,0,0,1.64.11,9,9,0,0,0-1.61-.34c-1-.18-2.56-.41-4.43-.62-3.76-.45-9-.84-14.73-.94a143.74,143.74,0,0,0-14.74.44c-1.88.16-3.4.35-4.44.51A8.81,8.81,0,0,0,65.86,108.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.62,151.05a2.18,2.18,0,0,0,.19-.54c.12-.42.26-.94.44-1.57.38-1.37.87-3.37,1.44-5.84,1.16-4.95,2.54-11.83,4-19.44s2.73-14.51,3.78-19.47c.52-2.41.95-4.4,1.26-5.87.14-.64.25-1.17.34-1.61a1.82,1.82,0,0,0,.07-.56,2.88,2.88,0,0,0-.19.54c-.12.42-.26.94-.44,1.57-.37,1.37-.86,3.36-1.44,5.84-1.16,4.94-2.54,11.83-4,19.44S135.34,138,134.29,143c-.52,2.41-.94,4.4-1.26,5.87l-.33,1.6A2.23,2.23,0,0,0,132.62,151.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.15,143a2.64,2.64,0,0,0,.57.13l1.64.25,6,.88c5.11.74,12.15,1.85,19.93,3.08s14.84,2.28,20,2.91c2.56.32,4.63.56,6.07.69L132,151a2,2,0,0,0,.58,0,2.64,2.64,0,0,0-.57-.13l-1.64-.25-6-.88c-5.11-.74-12.15-1.85-19.93-3.08s-14.84-2.28-20-2.92c-2.57-.31-4.64-.55-6.08-.69L76.73,143A2,2,0,0,0,76.15,143Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.91,109.39s-10.21-5-18.83,19-11.32,37.52-11.32,37.52-2.43,5.1-6.07,2.43-9.18-10.86-14.49-8.59c-5.51,2.36-6.58,9-4.3,18.21s6.53,29.64,6.91,31.49-.34,4.64-3.11,3.22-19.47-15.87-25.85-7.53,4.19,33,5.3,35.73.7,4-.55,4.86-6.4-4.52-11.32-8.43-11.32-7.59-14.59-2.47-2.08,24.49,20.17,53.38L388,300.87l16.73-3.07c35.39-8.76,48.39-23.17,49-29.22s-6.67-7.15-12.95-7.15-13.68,1-14.12-.45.05-2.7,2.6-4.14,26.2-14.17,26.4-24.67-21.87-9.59-24.92-10.2-1.85-3.26-.43-4.45,17.48-14.54,25-20.35,10.81-11.65,8-16.92c-2.74-5.09-12.18-2.14-16.68-2.31s-3.24-5.68-3.24-5.68,6.32-12.27,14.5-36.41-3.23-26.55-3.23-26.55",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.15,130.85s0,.18-.15.51-.27.86-.48,1.5c-.43,1.32-1.07,3.25-1.89,5.72-1.64,5-4.08,12.13-7.12,21-6.08,17.7-14.69,42.08-24.27,69S395,279.79,388.82,297.46c-3.07,8.82-5.56,16-7.28,20.93l-2,5.69c-.23.63-.4,1.12-.53,1.47s-.19.5-.19.5,0-.18.14-.51.28-.86.48-1.5c.44-1.33,1.08-3.25,1.89-5.72,1.65-5,4.08-12.13,7.13-21,6.08-17.7,14.68-42.08,24.27-69s18.25-51.25,24.42-68.92c3.07-8.82,5.55-16,7.28-20.93.86-2.45,1.52-4.37,2-5.69.23-.63.41-1.12.53-1.47S447.15,130.85,447.15,130.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5,171.47a4.57,4.57,0,0,1,.57,1.08c.34.71.8,1.76,1.35,3,1.1,2.59,2.53,6.2,4,10.22l3.82,10.3c.46,1.23.86,2.27,1.17,3.11a5.75,5.75,0,0,1,.39,1.16,5.74,5.74,0,0,1-.58-1.08c-.33-.71-.79-1.76-1.33-3.06-1.08-2.6-2.46-6.23-4-10.25s-2.85-7.53-3.89-10.26l-1.19-3.11A6.31,6.31,0,0,1,411.5,171.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.42,200.49c-.06-.13,7.26-3.41,16.35-7.32s16.5-7,16.56-6.83-7.26,3.41-16.35,7.32S424.48,200.62,424.42,200.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.83,241.13a6.3,6.3,0,0,1,1.23-.21l3.38-.42c2.84-.35,6.77-.86,11.08-1.58s8.2-1.48,11-2.07l3.33-.69a6.51,6.51,0,0,1,1.23-.2,5,5,0,0,1-1.18.4c-.78.22-1.9.52-3.3.85-2.79.68-6.67,1.52-11,2.23s-8.27,1.17-11.14,1.43c-1.43.13-2.59.22-3.39.25A5.47,5.47,0,0,1,407.83,241.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.37,217.45a5.52,5.52,0,0,1,.78.86l2,2.45c1.64,2.09,3.23,5.82,6.32,8.21,2.44,3.23,4.63,6.17,6.19,8.31l1.83,2.56a4.58,4.58,0,0,1,.61,1,5.24,5.24,0,0,1-.77-.86c-.54-.67-1.19-1.49-2-2.45-1.64-2.09-3.87-5-6.31-8.22s-4.64-6.16-6.2-8.3L391,218.43A4.89,4.89,0,0,1,390.37,217.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.17,251.47a9.21,9.21,0,0,1,1,1.11l2.53,3.13c2.11,2.66,5,6.36,8.18,10.46s6,7.84,8.05,10.56l2.4,3.24a8.44,8.44,0,0,1,.82,1.23,7.46,7.46,0,0,1-1-1.11L390.62,277c-2.12-2.66-5-6.36-8.18-10.47s-6-7.83-8.06-10.55L372,252.7A7.48,7.48,0,0,1,371.17,251.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,280.33a10.94,10.94,0,0,1,1.55-.31l4.26-.68c3.59-.58,8.55-1.4,14-2.46s10.36-2.13,13.91-2.94l4.21-.95a8.48,8.48,0,0,1,1.55-.29,11.18,11.18,0,0,1-1.5.49c-1,.28-2.41.67-4.17,1.11-3.53.9-8.44,2.05-13.9,3.1s-10.43,1.82-14,2.31c-1.81.24-3.27.41-4.29.52A8.45,8.45,0,0,1,393.78,280.33Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.72,453c0,.15-97.32.26-217.35.26S25,453.16,25,453s97.31-.26,217.38-.26S459.72,452.87,459.72,453Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Login--inject-62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.96,
    y: 65.52,
    width: 254.79,
    height: 319.64,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,65.52l254.79-.22H395v.22c0,91.3,0,201.28,0,319.6v.29h-.26l-254.79,0h-.23v-.23c.14-189.94.23-317.59.23-319.63,0,2,.1,129.69.24,319.63l-.24-.23,254.79,0-.26.26v0c0-118.32,0-228.3,0-319.6l.22.21Z",
    style: {
      fill: "#263238"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.12,90.86h2.56v11.61h7.2v2.16h-9.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.7,99.38a5.6,5.6,0,1,1,5.59,5.39A5.29,5.29,0,0,1,248.7,99.38Zm8.72,0a3.12,3.12,0,1,0-3.13,3.29A3.05,3.05,0,0,0,257.42,99.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.68,94.13V103c0,3.81-2,5.55-5.67,5.55a8.37,8.37,0,0,1-5.11-1.5l1.1-1.85a6.34,6.34,0,0,0,3.88,1.26c2.32,0,3.34-1.06,3.34-3.19v-.55a4.62,4.62,0,0,1-3.52,1.4,5.08,5.08,0,1,1,0-10.15,4.54,4.54,0,0,1,3.64,1.52v-1.4Zm-2.42,4.94a3.2,3.2,0,1,0-3.19,3A3,3,0,0,0,270.26,99.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.57,90.92a1.5,1.5,0,0,1,1.57-1.47,1.47,1.47,0,0,1,1.58,1.41,1.58,1.58,0,0,1-3.15.06Zm.33,3.21h2.46v10.5H275.9Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.93,98.61v6h-2.46v-5.7c0-1.87-.92-2.77-2.49-2.77-1.75,0-2.94,1.06-2.94,3.16v5.31h-2.45V94.13h2.34v1.36A4.53,4.53,0,0,1,287.55,94C290.06,94,291.93,95.45,291.93,98.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.78,83.77a5.16,5.16,0,0,1,.37,4A9.08,9.08,0,0,1,308,91.31a16,16,0,0,1-7.18,4c-.66-2.9.94-6,1.85-7.46,1.43-2.37,5.47-5.78,7.1-4.08",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,100.39A4.39,4.39,0,0,1,304,97.85a5.89,5.89,0,0,1,4.27,1.46,2.48,2.48,0,0,1,1,1.8,1.92,1.92,0,0,1-1.1,1.56,4,4,0,0,1-2,.29c-2.29-.17-4.47-.74-5.85-2.57",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.57,103.79a8,8,0,0,1,1.27-1.23,8.16,8.16,0,0,1,1.61-1.06,17.27,17.27,0,0,1,2.15-1,8.79,8.79,0,0,1,4.25-.49,5.86,5.86,0,0,1,1.26.33,1.42,1.42,0,0,1,.43.22s-.65-.22-1.72-.34a9.49,9.49,0,0,0-4.12.56,21,21,0,0,0-2.12.94,8.77,8.77,0,0,0-1.61,1A12.87,12.87,0,0,1,294.57,103.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.94,86.64a5.78,5.78,0,0,1-.46.78c-.31.48-.76,1.18-1.33,2-1.14,1.71-2.75,4.05-4.58,6.6s-3.57,4.81-4.85,6.42c-.64.81-1.17,1.45-1.54,1.89a5.62,5.62,0,0,1-.6.66,4.42,4.42,0,0,1,.51-.73l1.46-2c1.24-1.64,2.94-3.91,4.77-6.46L305,89.34l1.42-2A5.06,5.06,0,0,1,306.94,86.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,99.22a10.31,10.31,0,0,0-1.38-9.3c-.49-.67-1.24-1.34-2-1.14s-1.16,1.15-1.26,2a8.78,8.78,0,0,0,4.53,8.64",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,92.26s.11.13.27.39.36.64.6,1.13A11.62,11.62,0,0,1,297,97.85a7.4,7.4,0,0,1-.22,2.34A6.7,6.7,0,0,1,296,102a7.06,7.06,0,0,1-.76,1,2,2,0,0,1-.33.33c-.05,0,.39-.55.91-1.48a7.53,7.53,0,0,0,.67-1.72,7.45,7.45,0,0,0,.19-2.25,13.09,13.09,0,0,0-1.06-4A17.33,17.33,0,0,1,295,92.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.26,137v.73h-5.69v-8.05h5.52v.74h-4.67v2.86h4.16V134h-4.16v3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.07,134.2v3.51h-.81v-3.43c0-1.27-.65-1.93-1.74-1.93a2,2,0,0,0-2,2.19v3.17h-.81v-3.43c0-1.27-.65-1.93-1.75-1.93a2,2,0,0,0-2,2.19v3.17h-.81v-6.05h.78v1.11a2.43,2.43,0,0,1,2.22-1.15,2.17,2.17,0,0,1,2.15,1.27,2.64,2.64,0,0,1,2.39-1.27A2.28,2.28,0,0,1,178.07,134.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.86,134v3.75h-.79v-.94a2.27,2.27,0,0,1-2.08,1c-1.37,0-2.21-.71-2.21-1.76s.6-1.71,2.34-1.71H184v-.37c0-1-.59-1.6-1.72-1.6a3.13,3.13,0,0,0-2,.71l-.37-.61a3.89,3.89,0,0,1,2.46-.81A2.15,2.15,0,0,1,184.86,134ZM184,135.9v-1h-1.9c-1.17,0-1.55.46-1.55,1.08s.56,1.14,1.53,1.14A1.94,1.94,0,0,0,184,135.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,129.75a.58.58,0,0,1,.6-.57.57.57,0,0,1,.59.56.59.59,0,0,1-.59.6A.59.59,0,0,1,186.89,129.75Zm.18,1.91h.82v6.05h-.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.17,129.18H191v8.53h-.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.84,134v3.75h-.78v-.94a2.28,2.28,0,0,1-2.09,1c-1.36,0-2.2-.71-2.2-1.76s.59-1.71,2.33-1.71H200v-.37c0-1-.58-1.6-1.71-1.6a3.11,3.11,0,0,0-2,.71l-.37-.61a3.87,3.87,0,0,1,2.46-.81A2.15,2.15,0,0,1,200.84,134ZM200,135.9v-1h-1.9c-1.17,0-1.55.46-1.55,1.08s.56,1.14,1.53,1.14A1.94,1.94,0,0,0,200,135.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6,129.18v8.53h-.78v-1.19a2.62,2.62,0,0,1-2.34,1.25,3.08,3.08,0,0,1,0-6.15,2.66,2.66,0,0,1,2.31,1.19v-3.63Zm-.8,5.51a2.25,2.25,0,1,0-2.25,2.36A2.22,2.22,0,0,0,207.8,134.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,129.18v8.53h-.78v-1.19a2.65,2.65,0,0,1-2.34,1.25,3.08,3.08,0,0,1,0-6.15,2.63,2.63,0,0,1,2.3,1.19v-3.63Zm-.81,5.51a2.25,2.25,0,1,0-2.24,2.36A2.21,2.21,0,0,0,215.59,134.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.72,131.62v.79h-.19a2,2,0,0,0-2,2.23v3.08h-.82v-6.05h.79v1.19A2.27,2.27,0,0,1,221.72,131.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,134.94h-5.06a2.24,2.24,0,0,0,2.38,2.11,2.4,2.4,0,0,0,1.86-.8l.46.53a3.2,3.2,0,0,1-5.51-2.09,2.95,2.95,0,1,1,5.89,0C228.42,134.76,228.4,134.85,228.4,134.94Zm-5.06-.61h4.29a2.15,2.15,0,0,0-4.29,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.24,137l.37-.64a3.64,3.64,0,0,0,2.15.68c1.15,0,1.62-.39,1.62-1,0-1.58-3.92-.34-3.92-2.73,0-1,.85-1.72,2.39-1.72a4,4,0,0,1,2.14.56l-.35.66a3.12,3.12,0,0,0-1.79-.52c-1.09,0-1.57.42-1.57,1,0,1.63,3.92.4,3.92,2.73,0,1-.92,1.72-2.5,1.72A4,4,0,0,1,229.24,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.86,137l.37-.64a3.67,3.67,0,0,0,2.15.68c1.15,0,1.63-.39,1.63-1,0-1.58-3.93-.34-3.93-2.73,0-1,.85-1.72,2.4-1.72a4.07,4.07,0,0,1,2.14.56l-.36.66a3.08,3.08,0,0,0-1.78-.52c-1.1,0-1.58.42-1.58,1,0,1.63,3.92.4,3.92,2.73,0,1-.92,1.72-2.49,1.72A4.05,4.05,0,0,1,234.86,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.54,159.26h-5.06a2.24,2.24,0,0,0,2.38,2.1,2.37,2.37,0,0,0,1.85-.79l.46.53a3.2,3.2,0,0,1-5.51-2.09,2.92,2.92,0,0,1,3-3.08,2.89,2.89,0,0,1,2.93,3.08C175.55,159.08,175.54,159.17,175.54,159.26Zm-5.06-.61h4.29a2.15,2.15,0,0,0-4.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.9,162,179,159.5,177.05,162h-.92l2.39-3.1-2.28-3h.92l1.82,2.37L180.8,156h.89l-2.27,3,2.41,3.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.64,158.28V162h-.78v-.94a2.29,2.29,0,0,1-2.09,1c-1.37,0-2.2-.71-2.2-1.76s.59-1.71,2.33-1.71h1.92v-.37c0-1-.59-1.6-1.71-1.6a3.1,3.1,0,0,0-2,.71l-.36-.61a3.82,3.82,0,0,1,2.46-.82A2.16,2.16,0,0,1,187.64,158.28Zm-.82,1.93v-1h-1.9c-1.17,0-1.55.46-1.55,1.09s.56,1.14,1.53,1.14A1.93,1.93,0,0,0,186.82,160.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.84,158.52V162H199V158.6c0-1.27-.65-1.93-1.74-1.93a2,2,0,0,0-2,2.19V162h-.81V158.6c0-1.27-.65-1.93-1.75-1.93a2,2,0,0,0-2,2.19V162h-.81V156h.78v1.1a2.45,2.45,0,0,1,2.22-1.15,2.18,2.18,0,0,1,2.15,1.28,2.64,2.64,0,0,1,2.39-1.28A2.29,2.29,0,0,1,199.84,158.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19,159a2.93,2.93,0,0,1-3,3.08,2.64,2.64,0,0,1-2.3-1.2v3.37h-.81V156h.78v1.2a2.62,2.62,0,0,1,2.33-1.25A2.94,2.94,0,0,1,208.19,159Zm-.82,0a2.26,2.26,0,1,0-2.25,2.35A2.23,2.23,0,0,0,207.37,159Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.85,153.5h.82V162h-.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.22,159.26h-5.07a2.25,2.25,0,0,0,2.39,2.1,2.38,2.38,0,0,0,1.85-.79l.46.53a3.2,3.2,0,0,1-5.51-2.09,2.95,2.95,0,1,1,5.89,0C218.23,159.08,218.22,159.17,218.22,159.26Zm-5.07-.61h4.3a2.15,2.15,0,0,0-4.3,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.05,159c0,2-.72,3.11-1.91,3.11a1.23,1.23,0,0,1-1.3-1.25,2.56,2.56,0,0,1-2.3,1.25,3,3,0,0,1,0-5.94,2.58,2.58,0,0,1,2.28,1.21V156.2h.75v4.36c0,.64.32.87.71.87.71,0,1.17-.88,1.17-2.44a4.38,4.38,0,0,0-4.72-4.49,4.63,4.63,0,1,0,0,9.25,5,5,0,0,0,2.21-.51l.19.56a5.53,5.53,0,0,1-2.4.53,5.21,5.21,0,1,1,0-10.42A5,5,0,0,1,230.05,159Zm-3.22.13a2.19,2.19,0,1,0-2.19,2.31A2.14,2.14,0,0,0,226.83,159.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.38,156v5.32c0,2.08-1,3-3,3a4.22,4.22,0,0,1-2.82-.93l.41-.62a3.61,3.61,0,0,0,2.39.83c1.53,0,2.23-.71,2.23-2.2v-.77a2.73,2.73,0,0,1-2.36,1.17,2.94,2.94,0,1,1,0-5.87,2.73,2.73,0,0,1,2.39,1.21V156Zm-.8,2.88a2.3,2.3,0,1,0-2.3,2.22A2.16,2.16,0,0,0,236.58,158.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.65,158.52V162h-.82V158.6c0-1.27-.64-1.93-1.74-1.93a2,2,0,0,0-2,2.19V162h-.82V158.6c0-1.27-.64-1.93-1.75-1.93a2,2,0,0,0-2,2.19V162h-.82V156h.78v1.1a2.46,2.46,0,0,1,2.22-1.15,2.19,2.19,0,0,1,2.16,1.28,2.63,2.63,0,0,1,2.39-1.28A2.29,2.29,0,0,1,249.65,158.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.43,158.28V162h-.78v-.94a2.27,2.27,0,0,1-2.08,1c-1.37,0-2.21-.71-2.21-1.76s.59-1.71,2.33-1.71h1.92v-.37c0-1-.58-1.6-1.71-1.6a3.05,3.05,0,0,0-2,.71l-.37-.61a3.82,3.82,0,0,1,2.46-.82A2.16,2.16,0,0,1,256.43,158.28Zm-.82,1.93v-1h-1.9c-1.17,0-1.55.46-1.55,1.09s.57,1.14,1.53,1.14A1.93,1.93,0,0,0,255.61,160.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.46,154.07a.59.59,0,0,1,.6-.57.58.58,0,0,1,.6.56.59.59,0,0,1-.6.6A.6.6,0,0,1,258.46,154.07Zm.19,1.91h.81V162h-.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,153.5h.82V162h-.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3,161.46a.61.61,0,0,1,.61-.62.62.62,0,0,1,.63.62.63.63,0,0,1-.63.63A.62.62,0,0,1,264.3,161.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.49,159a3,3,0,0,1,3.12-3.08,2.67,2.67,0,0,1,2.37,1.2l-.61.42a2.07,2.07,0,0,0-1.76-.9,2.36,2.36,0,0,0,0,4.71,2,2,0,0,0,1.76-.88l.61.41a2.67,2.67,0,0,1-2.37,1.2A3,3,0,0,1,266.49,159Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.86,159a3.08,3.08,0,1,1,3.08,3.08A3,3,0,0,1,272.86,159Zm5.33,0a2.25,2.25,0,1,0-2.25,2.35A2.21,2.21,0,0,0,278.19,159Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.67,158.52V162h-.82V158.6c0-1.27-.64-1.93-1.74-1.93a2,2,0,0,0-2,2.19V162h-.82V158.6c0-1.27-.64-1.93-1.75-1.93a2,2,0,0,0-2,2.19V162h-.82V156h.78v1.1a2.46,2.46,0,0,1,2.22-1.15,2.17,2.17,0,0,1,2.15,1.28,2.66,2.66,0,0,1,2.4-1.28A2.29,2.29,0,0,1,290.67,158.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.82,172.39a1.77,1.77,0,0,0,1.11-.47c.73-.57.42-1.92.48-3.5,0-3.22,0-8-.05-14.06,0-1.53,0-3.14,0-4.84v-1.28a5.34,5.34,0,0,0-.08-1.28,1.53,1.53,0,0,0-.81-.9,2.93,2.93,0,0,0-1.31-.14l-12.09,0-29.47,0-170.68.07a1.4,1.4,0,0,0-1.13.57,1.94,1.94,0,0,0-.27,1.34v21.57c0,.48,0,1.06,0,1.47a1.36,1.36,0,0,0,.74,1,1.31,1.31,0,0,0,.61.15h20.18l45.32,0,76.73.06,51.73.08,14.06.05,3.66,0,1.25,0-1.25,0-3.66,0-14.06.05-51.73.08-76.73.06h-65.5a1.9,1.9,0,0,1-1.86-1.56c-.07-.59,0-1,0-1.56V148a8.06,8.06,0,0,1,0-.82,1.8,1.8,0,0,1,.34-.82,1.91,1.91,0,0,1,1.55-.79l170.68.08,29.47,0,12.09,0a3.13,3.13,0,0,1,1.41.17,1.75,1.75,0,0,1,.93,1,5.23,5.23,0,0,1,.09,1.35c0,.43,0,.86,0,1.28,0,1.7,0,3.31,0,4.84,0,6.1,0,10.84-.05,14.06,0,.81,0,1.51,0,2.13A1.73,1.73,0,0,1,375,172,1.52,1.52,0,0,1,373.82,172.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.87,192.84c0,1.71-1.24,2.75-3.29,2.75h-2.16v2.54h-.85v-8h3C165.63,190.08,166.87,191.11,166.87,192.84Zm-.85,0c0-1.29-.85-2-2.46-2h-2.14v4h2.14C165.17,194.84,166,194.1,166,192.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.05,194.38v3.75h-.79v-.94a2.27,2.27,0,0,1-2.08,1c-1.37,0-2.21-.72-2.21-1.76s.6-1.72,2.34-1.72h1.92v-.37c0-1-.59-1.59-1.72-1.59a3.07,3.07,0,0,0-2,.71l-.37-.61a3.84,3.84,0,0,1,2.46-.82A2.15,2.15,0,0,1,173.05,194.38Zm-.82,1.93v-1h-1.9c-1.17,0-1.55.46-1.55,1.08s.56,1.14,1.53,1.14A1.92,1.92,0,0,0,172.23,196.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.42,197.44l.37-.64a3.71,3.71,0,0,0,2.15.67c1.15,0,1.62-.39,1.62-1,0-1.57-3.92-.33-3.92-2.72,0-1,.85-1.73,2.39-1.73a4,4,0,0,1,2.14.57l-.35.65a3.09,3.09,0,0,0-1.79-.52c-1.09,0-1.57.43-1.57,1,0,1.64,3.92.41,3.92,2.73,0,1-.92,1.73-2.5,1.73A4,4,0,0,1,174.42,197.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.05,197.44l.36-.64a3.75,3.75,0,0,0,2.16.67c1.15,0,1.62-.39,1.62-1,0-1.57-3.93-.33-3.93-2.72,0-1,.86-1.73,2.4-1.73a4.07,4.07,0,0,1,2.14.57l-.36.65a3.08,3.08,0,0,0-1.78-.52c-1.1,0-1.58.43-1.58,1,0,1.64,3.92.41,3.92,2.73,0,1-.92,1.73-2.49,1.73A4,4,0,0,1,180.05,197.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.28,192.08l-2.29,6h-.77l-1.91-5-1.91,5h-.77l-2.28-6h.78l1.9,5.14,1.94-5.14h.7l1.94,5.14,1.92-5.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.72,195.1a3.08,3.08,0,1,1,3.08,3.09A3,3,0,0,1,195.72,195.1Zm5.33,0a2.25,2.25,0,1,0-2.25,2.36A2.21,2.21,0,0,0,201.05,195.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.59,192v.8l-.2,0a2,2,0,0,0-2,2.24v3.08h-.82v-6h.78v1.18A2.29,2.29,0,0,1,206.59,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.52,189.59v8.54h-.78v-1.2a2.61,2.61,0,0,1-2.33,1.26,3.08,3.08,0,0,1,0-6.16,2.66,2.66,0,0,1,2.3,1.2v-3.64Zm-.8,5.51a2.25,2.25,0,1,0-2.24,2.36A2.21,2.21,0,0,0,212.72,195.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.14,222.47v.74h-5.7v-8.06H176v.74H171.3v2.87h4.16v.72H171.3v3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.53,219.7v3.51h-.81v-3.43a1.69,1.69,0,0,0-1.82-1.93,2,2,0,0,0-2.12,2.18v3.18H178v-6.05h.78v1.11a2.54,2.54,0,0,1,2.3-1.16A2.31,2.31,0,0,1,183.53,219.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.94,222.84a1.94,1.94,0,0,1-1.28.43,1.6,1.6,0,0,1-1.77-1.76v-3.66h-1.08v-.69h1.08v-1.33h.82v1.33h1.84v.69h-1.84v3.61a1,1,0,0,0,1,1.1,1.33,1.33,0,0,0,.9-.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.47,220.43h-5.06a2.24,2.24,0,0,0,2.38,2.11,2.37,2.37,0,0,0,1.85-.79l.46.53a3.2,3.2,0,0,1-5.51-2.1,2.91,2.91,0,0,1,3-3.07,2.88,2.88,0,0,1,2.93,3.07C195.48,220.25,195.47,220.34,195.47,220.43Zm-5.06-.6h4.29a2.15,2.15,0,0,0-4.29,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.2,217.11v.79H200a2,2,0,0,0-2,2.23v3.09h-.81v-6.05h.78v1.18A2.29,2.29,0,0,1,200.2,217.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9,220.18a2.94,2.94,0,0,1-3,3.09,2.64,2.64,0,0,1-2.3-1.2v3.37h-.82v-8.28h.78v1.19a2.66,2.66,0,0,1,2.34-1.24A2.93,2.93,0,0,1,210.9,220.18Zm-.81,0a2.26,2.26,0,1,0-4.51,0,2.26,2.26,0,1,0,4.51,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.1,219.46v3.75h-.78v-1a2.26,2.26,0,0,1-2.08,1c-1.37,0-2.21-.72-2.21-1.76s.6-1.72,2.33-1.72h1.92v-.37c0-1-.58-1.6-1.71-1.6a3.06,3.06,0,0,0-2,.72l-.37-.61a3.82,3.82,0,0,1,2.46-.82A2.15,2.15,0,0,1,217.1,219.46Zm-.82,1.93v-1h-1.89c-1.18,0-1.56.46-1.56,1.08s.57,1.14,1.53,1.14A1.94,1.94,0,0,0,216.28,221.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.48,222.52l.37-.65a3.64,3.64,0,0,0,2.15.68c1.15,0,1.62-.39,1.62-1,0-1.57-3.92-.33-3.92-2.72,0-1,.85-1.73,2.39-1.73a4.17,4.17,0,0,1,2.14.56l-.36.66a3.08,3.08,0,0,0-1.78-.52c-1.09,0-1.58.43-1.58,1,0,1.64,3.93.41,3.93,2.73,0,1.05-.92,1.73-2.5,1.73A4.07,4.07,0,0,1,218.48,222.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.1,222.52l.37-.65a3.64,3.64,0,0,0,2.15.68c1.15,0,1.62-.39,1.62-1,0-1.57-3.92-.33-3.92-2.72,0-1,.85-1.73,2.39-1.73a4.11,4.11,0,0,1,2.14.56l-.35.66a3.12,3.12,0,0,0-1.79-.52c-1.09,0-1.57.43-1.57,1,0,1.64,3.92.41,3.92,2.73,0,1.05-.92,1.73-2.5,1.73A4.09,4.09,0,0,1,224.1,222.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.33,217.16,237,223.21h-.77l-1.91-5-1.91,5h-.77l-2.28-6.05h.79l1.89,5.14,1.95-5.14h.7l1.93,5.14,1.92-5.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.78,220.18a3.08,3.08,0,1,1,3.08,3.09A3,3,0,0,1,239.78,220.18Zm5.32,0a2.25,2.25,0,1,0-2.24,2.36A2.21,2.21,0,0,0,245.1,220.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.65,217.11v.79h-.2a2,2,0,0,0-2,2.23v3.09h-.81v-6.05h.78v1.18A2.29,2.29,0,0,1,250.65,217.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.58,214.67v8.54h-.78V222a2.63,2.63,0,0,1-2.34,1.26,3.08,3.08,0,0,1,0-6.16,2.62,2.62,0,0,1,2.3,1.2v-3.64Zm-.8,5.51a2.25,2.25,0,1,0-2.25,2.36A2.22,2.22,0,0,0,256.78,220.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,215.89v3.16h4.16v.74H325v3.42h-.86v-8.06h5.53v.74Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.45,220.18a3.08,3.08,0,1,1,3.09,3.09A3,3,0,0,1,330.45,220.18Zm5.33,0a2.25,2.25,0,1,0-2.24,2.36A2.21,2.21,0,0,0,335.78,220.18Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.32,217.11v.79h-.19a2,2,0,0,0-2,2.23v3.09h-.82v-6.05h.79v1.18A2.29,2.29,0,0,1,341.32,217.11Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.34,217.16v5.31c0,2.08-1,3-3,3a4.29,4.29,0,0,1-2.82-.93l.42-.63a3.58,3.58,0,0,0,2.38.83c1.53,0,2.23-.7,2.23-2.19v-.78a2.7,2.7,0,0,1-2.36,1.18,2.94,2.94,0,1,1,0-5.87,2.73,2.73,0,0,1,2.4,1.21v-1.16Zm-.79,2.87a2.3,2.3,0,1,0-2.31,2.22A2.17,2.17,0,0,0,347.55,220Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,220.18a3.08,3.08,0,1,1,3.08,3.09A3,3,0,0,1,350,220.18Zm5.32,0a2.25,2.25,0,1,0-2.24,2.36A2.21,2.21,0,0,0,355.34,220.18Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,222.84a1.92,1.92,0,0,1-1.28.43,1.61,1.61,0,0,1-1.77-1.76v-3.66h-1.08v-.69H358v-1.33h.82v1.33h1.84v.69h-1.84v3.61a1,1,0,0,0,1,1.1,1.32,1.32,0,0,0,.89-.31Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,217.21c0-.82-.68-1.4-1.86-1.4a2.66,2.66,0,0,0-2.19.93l-.61-.46a3.5,3.5,0,0,1,2.86-1.19c1.61,0,2.65.77,2.65,2,0,2-2.11,2.06-2.11,3.7h-.85C363.86,218.89,366,218.72,366,217.21Zm-2.28,5.46a.58.58,0,0,1,.6-.59.59.59,0,0,1,.61.59.61.61,0,0,1-.61.6A.6.6,0,0,1,363.69,222.67Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.82,233.57a1.76,1.76,0,0,0,1.11-.48c.73-.56.42-1.92.48-3.49,0-3.23,0-8-.05-14.07,0-1.52,0-3.14,0-4.83v-1.29a5.26,5.26,0,0,0-.08-1.27,1.58,1.58,0,0,0-.81-.91,3.08,3.08,0,0,0-1.31-.14l-12.09,0-29.47,0-170.68.08a1.37,1.37,0,0,0-1.13.57,1.93,1.93,0,0,0-.27,1.34V230.7c0,.49,0,1.07,0,1.48a1.39,1.39,0,0,0,.74,1,1.44,1.44,0,0,0,.61.15h20.18l45.32,0,76.73,0,51.73.08,14.06,0,3.66,0,1.25,0-1.25,0-3.66,0-14.06,0-51.73.08-76.73.06h-65.5a1.9,1.9,0,0,1-1.86-1.55c-.07-.6,0-1,0-1.57V209.14a8,8,0,0,1,0-.82,1.83,1.83,0,0,1,.34-.83,1.9,1.9,0,0,1,1.55-.78l170.68.07,29.47,0,12.09,0a3.28,3.28,0,0,1,1.41.17,1.77,1.77,0,0,1,.93,1.06,5.15,5.15,0,0,1,.09,1.34c0,.44,0,.86,0,1.29,0,1.69,0,3.31,0,4.83,0,6.1,0,10.84-.05,14.07,0,.8,0,1.51,0,2.12a1.72,1.72,0,0,1-.54,1.41A1.56,1.56,0,0,1,373.82,233.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69,330l.34-.66a3.91,3.91,0,0,0,2.65,1c1.51,0,2.17-.63,2.17-1.42,0-2.21-5-.86-5-3.84,0-1.18.92-2.2,3-2.2a4.5,4.5,0,0,1,2.49.71l-.28.68a4.18,4.18,0,0,0-2.21-.67c-1.48,0-2.13.66-2.13,1.46,0,2.21,5,.88,5,3.81,0,1.18-.95,2.2-3,2.2A4.39,4.39,0,0,1,245.69,330Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.18,323a.59.59,0,0,1,.6-.58.58.58,0,1,1-.6.58Zm.18,1.91h.82v6h-.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.46,327.45V331h-.82v-3.43a1.68,1.68,0,0,0-1.81-1.93,2,2,0,0,0-2.12,2.18V331h-.82v-6h.78V326a2.57,2.57,0,0,1,2.31-1.16A2.31,2.31,0,0,1,269.46,327.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.05,324.91v5.31c0,2.08-1,3-3,3a4.25,4.25,0,0,1-2.82-.93l.41-.63a3.6,3.6,0,0,0,2.38.83c1.53,0,2.23-.7,2.23-2.19v-.77a2.7,2.7,0,0,1-2.35,1.17,2.94,2.94,0,1,1,0-5.87,2.72,2.72,0,0,1,2.39,1.21v-1.16Zm-.79,2.87A2.3,2.3,0,1,0,259,330,2.17,2.17,0,0,0,261.26,327.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.62,324.91v6h-.78v-1.11a2.42,2.42,0,0,1-2.18,1.17,2.35,2.35,0,0,1-2.55-2.6v-3.51h.82v3.43c0,1.28.66,1.94,1.81,1.94a2,2,0,0,0,2.06-2.2v-3.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,327.93a2.94,2.94,0,0,1-3,3.09,2.66,2.66,0,0,1-2.3-1.2v3.37h-.82v-8.28h.79v1.19a2.63,2.63,0,0,1,2.33-1.24A2.93,2.93,0,0,1,289,327.93Zm-.82,0a2.26,2.26,0,1,0-2.25,2.36A2.23,2.23,0,0,0,288.22,327.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.82,340.88a1.77,1.77,0,0,0,1.11-.47c.73-.57.42-1.93.48-3.5,0-3.23,0-8-.05-14.07,0-1.52,0-3.14,0-4.83v-1.29a5.26,5.26,0,0,0-.08-1.27,1.58,1.58,0,0,0-.81-.91,3.08,3.08,0,0,0-1.31-.14l-12.09,0-29.47,0-170.68.08a1.4,1.4,0,0,0-1.13.57,1.93,1.93,0,0,0-.27,1.34V338c0,.49,0,1.07,0,1.48a1.37,1.37,0,0,0,.74,1,1.31,1.31,0,0,0,.61.15h20.18l45.32,0,76.73.05,51.73.09,14.06,0,3.66,0,1.25,0-1.25,0-3.66,0-14.06.05-51.73.08-76.73.06h-65.5a2,2,0,0,1-.84-.21,1.86,1.86,0,0,1-1-1.35c-.07-.6,0-1,0-1.57V316.45a8,8,0,0,1,0-.82,1.83,1.83,0,0,1,.34-.83,1.9,1.9,0,0,1,1.55-.78l170.68.07,29.47,0,12.09,0a3.28,3.28,0,0,1,1.41.17,1.77,1.77,0,0,1,.93,1.06,5.15,5.15,0,0,1,.09,1.34c0,.44,0,.87,0,1.29,0,1.69,0,3.31,0,4.83,0,6.1,0,10.84-.05,14.07,0,.8,0,1.51,0,2.12a1.71,1.71,0,0,1-.54,1.41A1.56,1.56,0,0,1,373.82,340.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.25,
    y: 264.72,
    width: 216.21,
    height: 26.6,
    rx: 11.07,
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.83,273.29h.85v7.32h4.51v.74h-5.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.73,278.32a3.08,3.08,0,1,1,3.09,3.08A3,3,0,0,1,256.73,278.32Zm5.33,0a2.25,2.25,0,1,0-2.24,2.36A2.21,2.21,0,0,0,262.06,278.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.16,275.29v5.32c0,2.08-1,3-3,3a4.22,4.22,0,0,1-2.82-.93l.42-.62a3.56,3.56,0,0,0,2.38.83c1.53,0,2.23-.7,2.23-2.2v-.77a2.73,2.73,0,0,1-2.36,1.17,2.93,2.93,0,1,1,0-5.86,2.71,2.71,0,0,1,2.39,1.21v-1.17Zm-.8,2.88a2.3,2.3,0,1,0-2.3,2.22A2.16,2.16,0,0,0,269.36,278.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.27,273.38a.6.6,0,0,1,1.2,0,.6.6,0,0,1-1.2,0Zm.18,1.91h.82v6.06h-.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.12,277.84v3.51h-.82v-3.43a1.7,1.7,0,0,0-1.82-1.94,2,2,0,0,0-2.12,2.19v3.18h-.81v-6.06h.78v1.12a2.53,2.53,0,0,1,2.3-1.16A2.32,2.32,0,0,1,284.12,277.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6,440.83l-1.29,7.35,1.09.24c4.88,1,24.87,4.91,28.31,4.42,3.84-.55-10.78-6.3-10.78-6.3l.46-3.11Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.79,449a6.23,6.23,0,0,0-1.69-4.15,6,6,0,0,0-4-1.94l-.78,5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71,449.61s5.07,2.36,4.28,3.13-21.15-2.38-30-4.56l.09-.39,23.7,3.88S70,449.5,71,449.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.12,447.73a1.1,1.1,0,0,0,.3.08l.87.19,3.22.64c2.72.53,6.49,1.2,10.66,1.85s8,1.15,10.73,1.48l3.26.37.89.09h.31l-.31-.06-.88-.12-3.25-.44c-2.75-.37-6.54-.9-10.71-1.55s-8-1.3-10.67-1.78l-3.23-.57-.88-.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.05,451.94a7.81,7.81,0,0,1,.85-1.45,7.42,7.42,0,0,1,1.29-1.07,2.39,2.39,0,0,0-1.46.93A2.48,2.48,0,0,0,69.05,451.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,448.46s.34-.23.67-.6.54-.7.5-.74-.35.23-.67.6S64.16,448.42,64.21,448.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.88,447.47s.35-.09.7-.32.6-.45.57-.5-.34.09-.69.32S62.85,447.42,62.88,447.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.23,445.65a4.21,4.21,0,1,0,1,.05A2.08,2.08,0,0,0,62.23,445.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1,444.41a1.85,1.85,0,0,0,1,.47,1.82,1.82,0,0,0,1.1,0,6.64,6.64,0,0,0-1-.24A6.59,6.59,0,0,0,62.1,444.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.05,447a3.75,3.75,0,0,0,1.15.17,7.27,7.27,0,0,0,1.26-.08,3.61,3.61,0,0,0,.74-.18.64.64,0,0,0,.34-.31.46.46,0,0,0-.1-.49,2.13,2.13,0,0,0-2.69.21,2.16,2.16,0,0,0-.5.71c-.07.19-.09.3-.07.31a3.16,3.16,0,0,1,.67-.9,2.12,2.12,0,0,1,1.08-.48,1.76,1.76,0,0,1,1.35.3c.16.16,0,.37-.17.45a3.1,3.1,0,0,1-.68.18,7.36,7.36,0,0,1-1.23.12C65.5,447,65.06,447,65.05,447Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.34,447.1s.23-.25.26-.77a1.91,1.91,0,0,0-.19-.89,1.16,1.16,0,0,0-.86-.73.45.45,0,0,0-.43.47,1.35,1.35,0,0,0,.11.55,3.64,3.64,0,0,0,.43.77c.31.41.57.59.59.57s-.2-.24-.46-.65a4.26,4.26,0,0,1-.37-.77c-.12-.26-.16-.71.13-.72s.54.35.68.6a2,2,0,0,1,.21.8A3.94,3.94,0,0,1,65.34,447.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.24,442.91s.51,0,1.31.25a5.82,5.82,0,0,1,2.69,1.63,5.9,5.9,0,0,1,1.4,2.82c.15.8.1,1.32.14,1.32a1.15,1.15,0,0,0,.06-.36,5.32,5.32,0,0,0-.05-1,5.57,5.57,0,0,0-1.39-2.94A5.66,5.66,0,0,0,47.58,443a4.73,4.73,0,0,0-1-.12A1,1,0,0,0,46.24,442.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3,447.65a10.92,10.92,0,0,0,2.56.66,10,10,0,0,0,2.64.19c0-.06-1.17-.17-2.6-.41S54.32,447.59,54.3,447.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.81,447.1c-.05,0,.06.26.13.55s.11.53.17.54.14-.27,0-.6S50.85,447.06,50.81,447.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.75,445.26s0,.24.19.45.32.36.37.33,0-.24-.19-.46S49.8,445.22,49.75,445.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,444.22c0,.06.24.09.49.23s.41.3.46.27,0-.31-.36-.47S48,444.16,48,444.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.69,443.66s.06.16.2.24.28.1.31.05-.06-.16-.2-.24S46.72,443.6,46.69,443.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.4,447.11l.67,7.44,1.12-.05c5-.28,25.28-1.76,28.48-3.13,3.56-1.53-12-3.26-12-3.26l-.37-3.12Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.55,453.69a6.26,6.26,0,0,0-2.71-3.57,6.09,6.09,0,0,0-4.34-.84l.56,5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.28,449.22s5.51.94,4.94,1.9-21,3.22-30.15,3.43l0-.4L165,451.7S165.24,449.38,166.28,449.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,454.17h.31l.89-.05,3.28-.22c2.76-.21,6.57-.54,10.78-1s8-1,10.74-1.37L170,451l.88-.15a2.4,2.4,0,0,0,.3-.06l-.31,0L170,451l-3.26.43c-2.74.36-6.54.84-10.74,1.3s-8,.82-10.77,1.07L142,454l-.89.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,452a7,7,0,0,1,.43-1.62,7.63,7.63,0,0,1,1-1.37,2.47,2.47,0,0,0-1.17,1.28A2.34,2.34,0,0,0,165,452Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.39,449.89c.05,0,.27-.31.49-.76a2,2,0,0,0,.29-.84s-.27.31-.49.75S159.33,449.86,159.39,449.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,449.28c.05,0,.31-.18.59-.49s.46-.6.42-.64-.31.18-.59.49S157.81,449.24,157.85,449.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.75,447.69a2,2,0,0,0,.95,0,2.09,2.09,0,0,0,.92-.2,2,2,0,0,0-1,0A2.09,2.09,0,0,0,156.75,447.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3,446.53a1.82,1.82,0,0,0,1.08.19,1.76,1.76,0,0,0,1.06-.27,6,6,0,0,0-1.07.05A5.76,5.76,0,0,0,156.3,446.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.82,448.25a3.21,3.21,0,0,0,1.15-.13,6.33,6.33,0,0,0,1.2-.41,3.39,3.39,0,0,0,.67-.36.64.64,0,0,0,.25-.39.49.49,0,0,0-.23-.45,2.14,2.14,0,0,0-2.54.91,1.89,1.89,0,0,0-.29.81.68.68,0,0,0,0,.32,3.24,3.24,0,0,1,.42-1,2,2,0,0,1,.91-.75,1.79,1.79,0,0,1,1.38-.06c.2.11.15.34,0,.48a3.33,3.33,0,0,1-.61.35,7.86,7.86,0,0,1-1.16.44C160.26,448.17,159.82,448.22,159.82,448.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.13,448.28a1.16,1.16,0,0,0,0-.82,1.75,1.75,0,0,0-.41-.8,1.13,1.13,0,0,0-1-.48.47.47,0,0,0-.3.57,1.34,1.34,0,0,0,.26.49,3.46,3.46,0,0,0,.62.64,1.72,1.72,0,0,0,.71.39s-.25-.18-.61-.51a4.06,4.06,0,0,1-.56-.64c-.19-.22-.34-.65-.06-.73s.61.19.81.4a1.94,1.94,0,0,1,.41.71A4.63,4.63,0,0,1,160.13,448.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.59,449.22s.51-.1,1.33-.1a5.65,5.65,0,0,1,5.11,3.22c.36.74.44,1.26.48,1.25s0-.14,0-.37a4.24,4.24,0,0,0-.3-.94,5.48,5.48,0,0,0-5.25-3.31,4.22,4.22,0,0,0-1,.13A1.3,1.3,0,0,0,140.59,449.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.61,451.69a10.62,10.62,0,0,0,2.65,0,10.84,10.84,0,0,0,2.6-.5c0-.07-1.18.14-2.62.28S149.61,451.62,149.61,451.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,452.07c0,.05.12.24.27.49s.24.49.31.48.06-.29-.12-.59S146.13,452,146.1,452.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.59,450.57c0,.05.1.22.31.39s.4.26.44.22-.1-.22-.3-.39S144.63,450.52,144.59,450.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.62,450c0,.06.25,0,.53.09s.48.19.52.14-.14-.28-.48-.35S142.59,450,142.62,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.23,449.82c0,.06.1.14.25.18s.29,0,.31,0-.1-.14-.25-.18S141.24,449.76,141.23,449.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.62,165c-1.43-7.65-9.88-11.9-13.18-19-1.29-2.74-1.75-5.83-3.16-8.51a13.69,13.69,0,0,0-16.69-6.05l-.53.82c3.42,7.18,6.83,12.11,10.24,19.28a25.71,25.71,0,0,1,2.72,7.85c.31,2.77-.43,5.81-2.57,7.59-1.72,1.42-4,1.85-5.9,3.09a9.62,9.62,0,0,0-3.77,8.94,16.19,16.19,0,0,0,4.45,9c2.2,2.41,5.68,4.47,8.58,3,1.47-.76,2.38-2.24,3.46-3.49,2.22-2.55,5.28-4.17,8-6.17C142.49,177.56,146.81,171.37,145.62,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.16,200.56c-1.92,1.75-12.37,10.53-12.37,10.53l-10.37-9.44c.27-.77,2.81-5.13,3.1-6.22a8.29,8.29,0,0,0,.26-2.89,13.25,13.25,0,0,0-.64-3.56c-.46-1,.56-2.06,1.44-1.56s2.2,3.28,2.16,6.86,14-4.64,16-2.63Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,186.47l34.4,41.17L196,199.08l13.78,13.44s-39.65,43.63-45.7,43.32-26.6-13.9-26.6-13.9Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.09,180.34a.56.56,0,0,0-.7.33L198,204.25a.89.89,0,0,0,.45,1.14l11.1,5.3a.9.9,0,0,0,1.21-.46l10.51-24.44a.9.9,0,0,0-.53-1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.79 182.04 199.19 203.08 210.82 208.35 219.63 186.04 207.79 182.04",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.44,218.65a15.46,15.46,0,0,1-2.45-1.73c-1.45-1.15-3.39-2.81-5.42-4.78s-3.73-3.88-4.92-5.3a14.16,14.16,0,0,1-1.79-2.39,21.93,21.93,0,0,1,2.07,2.15c1.25,1.35,3,3.2,5,5.16s3.9,3.66,5.29,4.87A21.72,21.72,0,0,1,204.44,218.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.55,203.1c.07.06-.36.4-.31,1.13a1.42,1.42,0,0,0,.51,1,1.3,1.3,0,0,0,2-1.13,1.44,1.44,0,0,0-.63-1,2.31,2.31,0,0,0-1.14-.3s.09-.12.33-.17a1.45,1.45,0,0,1,1,.15,1.72,1.72,0,0,1,.92,1.21,1.73,1.73,0,0,1-2.73,1.57,1.69,1.69,0,0,1-.59-1.4,1.5,1.5,0,0,1,.37-.94C194.4,203.12,194.54,203.08,194.55,203.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.06,239.67a5.19,5.19,0,0,1-.51-1.79,16.3,16.3,0,0,1,1-8.81,5,5,0,0,1,.9-1.63,36,36,0,0,0-1.49,6A36.43,36.43,0,0,0,163.06,239.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,239.35a5.24,5.24,0,0,1-1.11-1.54,19.15,19.15,0,0,1-2.54-8.76,5.43,5.43,0,0,1,.11-1.9,52.19,52.19,0,0,0,1.13,6.29A51,51,0,0,0,168,239.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.99 185.96 202.3 200.11 210.82 203.6 216.76 189.14 207.99 185.96",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.07,
    y: 198.79,
    width: 6.92,
    height: 1.71,
    rx: 0.73,
    transform: "translate(93.03 -64.58) rotate(22.68)",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.22,
    y: 189.44,
    width: 6.75,
    height: 0.98,
    transform: "translate(80.5 -62.38) rotate(20.63)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.5,
    y: 192.47,
    width: 7.46,
    height: 1.93,
    transform: "translate(81.65 -61.67) rotate(20.63)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.34,
    y: 195.37,
    width: 7.46,
    height: 1.93,
    transform: "translate(82.6 -61.08) rotate(20.63)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,191.65c-1.61.26-3.57.42-5.18.69a3,3,0,0,0-1.3.43A1,1,0,0,0,212,194c.25.45.89.49,1.41.48l3.55-.12a18.75,18.75,0,0,0-4.47.75c-.66.22-1.4.67-1.42,1.37a1.31,1.31,0,0,0,1.18,1.18,14.78,14.78,0,0,0,1.86,0s2.43,0,2.53.36c-1.51,0-3.52.31-5,.45-.42,0-.61.6-.71,1a.94.94,0,0,0,.44,1.06,1.36,1.36,0,0,0,.6.06l5.88-.18",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.84,184s7.15-.84,12.17,2.46c4.53,3,20.43,48.54,19.81,62.06s1.11,37.36,3.89,47.18,4.88,95-17,135.58l-40.75-5.72,12.74-109.43-1.3-99.27Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.49,184s7.16-.84,12.18,2.46c4.53,3,20.42,48.54,19.81,62.06s1.1,37.36,3.89,47.18,4.88,95-17,135.58l-37.25-5.72,9.24-109.43L105,216.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100.51,181.91S78.1,179.5,84.09,211.53l5.76,33.7,36.59,22.14c4.94,1.33.74-23,8.18-34.26,2.79-4.21,3-7.36,2.79-9.3.71-7.35-5.18-11.93-6-19.36-.92-10.76-.88-16.72-5.56-17.93l-25.32-4.61",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82,201.89a9.83,9.83,0,0,0,0,4.72,19,19,0,0,0,2,4.78,41.5,41.5,0,0,1,2.86,5.78,18.41,18.41,0,0,1,.15,11.61,16.65,16.65,0,0,1-1.42,3.25,5.38,5.38,0,0,1-.74,1.08,30.13,30.13,0,0,0,1.81-4.44,18.9,18.9,0,0,0-.29-11.32,44.93,44.93,0,0,0-2.79-5.73,18.15,18.15,0,0,1-1.9-4.93,8.92,8.92,0,0,1-.06-3.56,5.38,5.38,0,0,1,.27-.94C131.75,202,131.8,201.88,131.82,201.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6,184.22c-.53-5.51-1-11.32-1-11.32s7-1.88,7.54-11.29c.53-9-2.18-24.6-2.18-24.6v-.79c-10.63-3.16-23.21-3-29.69,5.86h0l5,44.7c.59,5.19,5.51,8.83,11.06,8.16h0C117,194.27,121.1,189.47,120.6,184.22Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,148.36a1.2,1.2,0,0,1-1,1.31,1.14,1.14,0,0,1-1.33-.95,1.2,1.2,0,0,1,1-1.31A1.14,1.14,0,0,1,125,148.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,147.05c-.14.17-1.1-.4-2.38-.28s-2.15.87-2.31.72,0-.35.43-.69a3.27,3.27,0,0,1,1.83-.77,3.12,3.12,0,0,1,1.91.42C124.87,146.71,125,147,125,147.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.68,150.09a1.2,1.2,0,0,1-1,1.31,1.14,1.14,0,0,1-1.33-1,1.2,1.2,0,0,1,1-1.31A1.14,1.14,0,0,1,111.68,150.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.67,148.83c-.13.17-1.1-.41-2.37-.28s-2.15.86-2.31.72.05-.36.43-.7a3.27,3.27,0,0,1,1.83-.76,3.14,3.14,0,0,1,1.91.41C111.58,148.49,111.74,148.75,111.67,148.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.25,157.85a8.54,8.54,0,0,1,2-.57c.32-.07.62-.17.65-.39a1.57,1.57,0,0,0-.31-.95l-1.21-2.39a43.92,43.92,0,0,1-2.81-6.29,42.43,42.43,0,0,1,3.31,6.05l1.17,2.41a1.89,1.89,0,0,1,.3,1.26.81.81,0,0,1-.49.53,1.88,1.88,0,0,1-.55.13A7.76,7.76,0,0,1,117.25,157.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.62,172.9a23.73,23.73,0,0,1-12.73-2.09s3.63,6.06,12.82,4.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,161a2.31,2.31,0,0,0-2.15-.65,2.1,2.1,0,0,0-1.38.92,1.34,1.34,0,0,0,0,1.53,1.57,1.57,0,0,0,1.72.26,4.86,4.86,0,0,0,1.54-1.14,1.45,1.45,0,0,0,.33-.41.44.44,0,0,0-.05-.48",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57,159.11c.21,0,.35,1.35,1.63,2.22s2.75.57,2.78.76-.3.31-.93.38a3.42,3.42,0,0,1-2.31-.55,3.09,3.09,0,0,1-1.28-1.88C113.35,159.47,113.48,159.11,113.57,159.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.71,310.17,62.5,368.73S45.56,438.85,45,440.7l-.53,2.18,23.87,1.8L109.7,314.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.68,351.28c3.86,18.67,18,97,18,97l24.21-2.49-13.77-99.91a32.81,32.81,0,0,0-1.58-7.66l-22.63-67.85L81.35,243.3c-.42,0-6.89,17.49-6,29.61A31.05,31.05,0,0,0,80.82,288c2.71,3.95,6.48,9.46,7.32,10.74C89.49,300.78,119.68,351.28,119.68,351.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.27,266.82c-1.16,4.22-2.13,8.49-2.88,12.8-2.72,15.69-9.64,53.87-14.13,64-5.69,12.8-14.93,61.15-12.09,70s64.71,17.78,64.71,17.78,3.55-57.95,7.11-72.52,11-46.58,12.08-65.42.71-51.55-5.33-71.81-19.94-41.55-19.94-41.55-11.88,3.28-15.93,8c0,0-4.94,6.06-5,11.83s-2.74,33.2-4.53,49.14C74.78,253.62,72.77,261.41,71.27,266.82Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13,292.5a.85.85,0,0,1,0-.29c0-.22,0-.5,0-.85,0-.78-.09-1.87-.16-3.26a105,105,0,0,0-1.15-12,40.15,40.15,0,0,0-2.17-8,30.76,30.76,0,0,0-4.77-8.14c-2.05-2.63-4.48-5.18-6.84-8a47.92,47.92,0,0,1-3.39-4.46,25.74,25.74,0,0,1-2.63-5.15,16.81,16.81,0,0,1-.62-11.25,22.53,22.53,0,0,1,2.61-4.74,9.07,9.07,0,0,0,1-2.3,3.44,3.44,0,0,0,.09-1.19,2.4,2.4,0,0,0-.4-1.07,3.59,3.59,0,0,0-1.86-1.34c-.75-.28-1.54-.49-2.29-.84a4.45,4.45,0,0,1-1.87-1.56,5.57,5.57,0,0,1-.8-2.21,14.77,14.77,0,0,1,.11-4.37c.2-1.37.39-2.69.57-3.94.74-5,1.33-9.06,1.75-11.9.22-1.38.38-2.46.5-3.24l.15-.83a2.45,2.45,0,0,1,.06-.29.91.91,0,0,1,0,.29c0,.22,0,.5-.09.85-.1.78-.23,1.86-.41,3.24-.38,2.86-.92,6.92-1.58,11.93-.17,1.26-.35,2.58-.54,3.95a14.64,14.64,0,0,0-.09,4.24,5.15,5.15,0,0,0,.75,2,3.91,3.91,0,0,0,1.7,1.4c.69.32,1.47.52,2.26.81a4.08,4.08,0,0,1,2.1,1.52,3,3,0,0,1,.47,1.27,3.88,3.88,0,0,1-.1,1.36,8.9,8.9,0,0,1-1.08,2.44,22.53,22.53,0,0,0-2.56,4.66,16.37,16.37,0,0,0,.63,10.9,31.72,31.72,0,0,0,5.92,9.46c2.34,2.8,4.77,5.36,6.83,8A31.49,31.49,0,0,1,123,268a39.93,39.93,0,0,1,2.13,8.06,93.59,93.59,0,0,1,1,12q0,2.09.06,3.27v.85C126.14,292.4,126.13,292.5,126.13,292.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,300.42s.05-.16.29-.32a1.67,1.67,0,0,1,1.17-.2,1.64,1.64,0,0,1,1.34,1.18,1.78,1.78,0,0,1-2.94,1.82,1.63,1.63,0,0,1-.44-1.73,1.69,1.69,0,0,1,.74-.94c.25-.13.41-.13.42-.1a2.13,2.13,0,0,0-.8,1.14,1.24,1.24,0,0,0,.4,1.27,1.31,1.31,0,0,0,2.15-1.34,1.26,1.26,0,0,0-.95-.94A2.31,2.31,0,0,0,118.24,300.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.61,334.88s.06-.16.3-.31a1.61,1.61,0,0,1,1.17-.21,1.66,1.66,0,0,1,1.34,1.18,1.78,1.78,0,0,1-2.94,1.82,1.69,1.69,0,0,1,.29-2.66c.25-.14.42-.14.42-.11a2.26,2.26,0,0,0-.8,1.14,1.26,1.26,0,0,0,.41,1.27,1.42,1.42,0,0,0,1.59.16,1.43,1.43,0,0,0,.56-1.5,1.26,1.26,0,0,0-1-.94A2.37,2.37,0,0,0,111.61,334.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,291.77a1.1,1.1,0,0,1,0,.33q0,.38-.09,1c-.09.89-.23,2.15-.41,3.76-.38,3.27-1,8-1.83,13.82-.44,2.91-1,6.09-1.67,9.48a30.92,30.92,0,0,1-1.44,5.2,5.65,5.65,0,0,1-.31.66,2.5,2.5,0,0,1-.5.57,5.26,5.26,0,0,1-1.24.8,15.24,15.24,0,0,1-2.76.95A65.58,65.58,0,0,1,89,329.7a125.66,125.66,0,0,1-13.12-.15l-.56-.07a.81.81,0,0,1-.6-.43,3.14,3.14,0,0,1-.31-1.14,14.64,14.64,0,0,1-.06-2.19c0-1.44.18-2.85.34-4.24.33-2.79.76-5.5,1.21-8.13.9-5.26,1.89-10.21,2.87-14.74l0-.17H79a141,141,0,0,0,23.67-4.11c2.81-.74,5-1.41,6.49-1.86l1.73-.53a4.57,4.57,0,0,1,.56-.16l-.15.06-.44.16c-.39.15-.92.35-1.66.6-1.47.5-3.66,1.2-6.46,2A133.84,133.84,0,0,1,79,298.88l.2-.18c-1,4.53-1.93,9.48-2.82,14.73-.44,2.63-.86,5.34-1.18,8.11-.16,1.38-.3,2.79-.34,4.2a13.49,13.49,0,0,0,.06,2.11,3,3,0,0,0,.24.94c.09.12.12.16.23.18l.53.06a124.45,124.45,0,0,0,13.06.16,64.89,64.89,0,0,0,12-1.33,14.32,14.32,0,0,0,2.68-.91,3.08,3.08,0,0,0,1.83-1.79,30.6,30.6,0,0,0,1.44-5.1c.72-3.37,1.26-6.55,1.72-9.45.93-5.81,1.56-10.52,2-13.78.22-1.61.39-2.87.51-3.76.06-.4.1-.73.14-1S111.4,291.77,111.4,291.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.76,299.06a6,6,0,0,1-1.19.62c-.78.37-1.94.85-3.38,1.39A63.82,63.82,0,0,1,82.49,305c-1.55,0-2.8-.13-3.65-.23a7.24,7.24,0,0,1-1.33-.19,6,6,0,0,1,1.34,0c.86,0,2.1.06,3.64.06a73,73,0,0,0,23.57-3.92c1.46-.5,2.63-.93,3.43-1.24A6.74,6.74,0,0,1,110.76,299.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.64,270.86l.09-.47c.07-.34.17-.79.3-1.38.29-1.22.71-3,1.24-5.26,1.1-4.56,2.77-11.14,4.94-19.24l3.59-13.24c1.3-4.76,2.67-9.85,4.3-15.16a122.75,122.75,0,0,1,6.17-16.29,75.38,75.38,0,0,1,4.43-8.09,29.25,29.25,0,0,1,2.77-3.85,11.74,11.74,0,0,1,3.77-3,6.51,6.51,0,0,1,4.84-.38,8.32,8.32,0,0,1,3.86,2.83c2,2.58,2.5,5.82,2.79,8.79.51,6,1,11.82,1.47,17.35.92,11.05,1.75,21,2.45,29.36s1.23,15.1,1.61,19.8c.18,2.32.32,4.13.41,5.39,0,.6.07,1.06.1,1.4a4.32,4.32,0,0,1,0,.48s0-.16-.07-.47-.08-.81-.14-1.4l-.51-5.38c-.42-4.7-1-11.45-1.77-19.79s-1.6-18.31-2.57-29.35c-.48-5.53-1-11.33-1.5-17.34-.29-2.95-.79-6.1-2.68-8.52A7.82,7.82,0,0,0,90.92,185a5.93,5.93,0,0,0-4.45.35,11.36,11.36,0,0,0-3.61,2.9A28.16,28.16,0,0,0,80.14,192a75.18,75.18,0,0,0-4.41,8,123.56,123.56,0,0,0-6.17,16.21c-1.64,5.29-3,10.38-4.34,15.13s-2.54,9.18-3.65,13.22c-2.22,8.09-3.94,14.66-5.1,19.2-.58,2.26-1,4-1.33,5.24-.16.58-.27,1-.36,1.36S54.64,270.86,54.64,270.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.19,267.41c-.39,1.56-7.66,42.93-7.66,42.93l54.09,1.75,7.45-42.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.51,270a3.25,3.25,0,0,1-.49.37c-.32.23-.82.55-1.46,1-1.27.82-3.15,2-5.51,3.31s-5.21,2.88-8.46,4.42c-1.63.76-3.32,1.57-5.19,2.24a18,18,0,0,1-6,.88A28.36,28.36,0,0,1,67,279.24,41.7,41.7,0,0,1,59,274c-2.11-1.72-3.71-3.23-4.8-4.28-.54-.53-1-.95-1.24-1.24a3.44,3.44,0,0,1-.4-.46,3,3,0,0,1,.48.38c.33.31.77.69,1.3,1.17,1.13,1,2.76,2.47,4.89,4.14a42.55,42.55,0,0,0,8,5.06,28.33,28.33,0,0,0,11.12,2.84,17.75,17.75,0,0,0,5.87-.84c1.8-.65,3.53-1.45,5.15-2.19,3.24-1.52,6.1-3,8.48-4.31s4.28-2.4,5.59-3.16l1.51-.88A2.18,2.18,0,0,1,105.51,270Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2,271.82c.14,0-1.31,9-3.24,20.13S95.35,312,95.21,312s1.31-9,3.24-20.12S102.06,271.8,102.2,271.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.76,280.54c-.15,1.34-.29,2.69-.44,4a3.61,3.61,0,0,0,0,1.27,1.2,1.2,0,0,0,.84.89,1.19,1.19,0,0,0,1.2-.69,3.54,3.54,0,0,0,.29-1.45c.07-1.44.15-2.88.23-4.31H77.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9,185.56c4.4-1.48,8.07,4.22,8.57,8.83a98.89,98.89,0,0,1,.3,16c-.79,15.76-7.92,30.83-7.92,30.83L134.09,248l-1.66,17.4-57.21-6.14a13.56,13.56,0,0,1-11.53-17.46C68.8,225.13,77.15,201.16,79,197.19,81.56,191.84,81.85,187.58,87.9,185.56Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.06,258.8l.3,0,.86.12,3.31.5c2.9.4,7.11,1,12.4,1.61,10.58,1.25,25.44,2.73,42.51,4l-.27.23c.53-5.53,1.09-11.37,1.66-17.37v0l.22.28-45.23-6.81-.25,0,.08-.23c2.94-9.1,5.19-16.63,6.53-21.93.68-2.64,1.15-4.73,1.44-6.15l.33-1.62c.08-.36.13-.55.13-.55s0,.19-.06.56-.14.92-.28,1.64c-.25,1.43-.69,3.52-1.33,6.18-1.27,5.32-3.46,12.88-6.36,22l-.18-.27,45.26,6.71.24,0,0,.25v0c-.57,6-1.13,11.83-1.66,17.37l0,.25-.24,0c-17.08-1.34-31.94-2.89-42.52-4.23-5.28-.66-9.49-1.3-12.38-1.76L74.2,259l-.85-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.52,264.62a76.31,76.31,0,0,1,.57-9,76.08,76.08,0,0,1,1.1-9,80.53,80.53,0,0,1-.58,9A79.37,79.37,0,0,1,123.52,264.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,249.57s.12-.07.34,0a1.27,1.27,0,0,1,.78.53,1.3,1.3,0,0,1,.08,1.43,1.5,1.5,0,0,1-2.79-.54,1.45,1.45,0,0,1,.47-1.34c.65-.55,1.22-.36,1.19-.31s-.49.08-.93.57a1.09,1.09,0,0,0-.26,1,1.15,1.15,0,0,0,.83.86,1.12,1.12,0,0,0,1.08-.48,1,1,0,0,0,0-1C129.76,249.68,129.26,249.65,129.27,249.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.84 242.87 145.9 264.3 156.35 264.3 158.85 242.87 143.84 242.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.84,240.1a4.48,4.48,0,0,0-1,2.83h17a3.15,3.15,0,0,0-1-2.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.77 238.13 145.2 240.25 158.01 240.35 157.16 238.11 145.77 238.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.62,248.23c0,.2,1.25,10.79,1.25,10.79h12.77l1.21-10.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.42,246.34l-.33,3.59,12.36.29s0,4.17-1.25,5.42c0,0,1.25,2.5-.14,3.89s-2.22,1-2.22,1,.56,2.78-.83,3.48-19.42-.38-19.42-.38L133.7,252l4-.35C137.87,247.8,141.85,245.89,144.42,246.34Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77,137.1a9.19,9.19,0,0,0-3.93-5,6.9,6.9,0,0,0-4.19-.86l0,0,0-.3c-1.34-2.41-4-2.93-6.74-2.47s-5.44,2.46-7.88,3.76c-3.3,1.76-6.45,3.77-9.61,5.78-2.62,1.67-5.3,3.41-7.11,5.93a12.34,12.34,0,0,0-2.07,9.3c.65,3.51,2.81,7.06,1.53,10.39-.86,2.21-3,3.6-4.46,5.5a8.89,8.89,0,0,0-.19,10.36c1.46,2,3.69,3.14,5.73,4.48,3.23,2.13,6.12,4.81,9.6,6.52s7.89,2.26,11.09.08,4.36-6.75,3.77-10.7-2.49-7.55-4-11.24a62.21,62.21,0,0,1-4.11-15c-.29-2.06-.45-4.26.52-6.09.88-1.64,2.53-2.69,4-3.81a31.88,31.88,0,0,0,8.58-9.8,12.51,12.51,0,0,0,3.43,4.8,31.06,31.06,0,0,0,6.73,4.76A15.56,15.56,0,0,0,128.77,137.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.27,434.17c-.67-2.64,1.08-5.29,3-7.2s4.29-3.61,5.32-6.14c1.66-4.1-.51-9.44,2.3-12.85,1.66-2,4.61-2.66,6.08-4.81a11.17,11.17,0,0,0,1.34-3.85,39.09,39.09,0,0,1,9.83-18.14,33.9,33.9,0,0,1-3.92,17.52c-1.14,2.15-2.54,4.24-2.93,6.65-.63,3.9,1.52,7.94.54,11.77-1.12,4.38-6.06,7.29-6.32,11.8-.22,3.82,3.09,7.19,2.82,11a10.32,10.32,0,0,1-1.73,4.52c-3,4.89-7.33,8.25-13.91,8.1l-8.05.24Z",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M444.27,434.17c-.67-2.64,1.08-5.29,3-7.2s4.29-3.61,5.32-6.14c1.66-4.1-.51-9.44,2.3-12.85,1.66-2,4.61-2.66,6.08-4.81a11.17,11.17,0,0,0,1.34-3.85,39.09,39.09,0,0,1,9.83-18.14,33.9,33.9,0,0,1-3.92,17.52c-1.14,2.15-2.54,4.24-2.93,6.65-.63,3.9,1.52,7.94.54,11.77-1.12,4.38-6.06,7.29-6.32,11.8-.22,3.82,3.09,7.19,2.82,11a10.32,10.32,0,0,1-1.73,4.52c-3,4.89-7.33,8.25-13.91,8.1l-8.05.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M437,453a6.59,6.59,0,0,1-2.22-.06,13.94,13.94,0,0,1-2.61-.67,11.15,11.15,0,0,1-3.22-1.79,4.45,4.45,0,0,1-1.32-1.78,8.27,8.27,0,0,1-.37-2.41,23.3,23.3,0,0,0-.17-2.6,7.3,7.3,0,0,0-1-2.6c-.94-1.67-2.51-3.26-3-5.53s-.13-4.64.25-7.05.77-5.05-.14-7.57-2.6-4.8-3.47-7.65-.44-5.95-.6-9a12.05,12.05,0,0,0-1-4.48c-.64-1.43-1.54-2.78-2.23-4.28-1.42-3-1.65-6.48-2-9.86-.18-1.69-.36-3.41-.55-5.14a25.64,25.64,0,0,0-.86-5.16,46.76,46.76,0,0,0-1.9-5,15.79,15.79,0,0,1-.92-2.61c-.15-.95-.19-1.84-.25-2.77a32.48,32.48,0,0,1,.25-5.57c.23-1.86.58-3.7.79-5.56l0-.32.05-.37.33.16A12.41,12.41,0,0,1,415.2,357a19.5,19.5,0,0,1,2.64,4.92,61,61,0,0,1,2.45,10.56,28.49,28.49,0,0,0,3.25,9.75c.87,1.44,1.93,2.76,2.86,4.16a11.55,11.55,0,0,1,2,4.6c.46,3.41-1.44,6.39-1.06,9.41a10.57,10.57,0,0,0,1.44,4.19c.73,1.29,1.58,2.49,2.39,3.69a23.49,23.49,0,0,1,2.14,3.73,11.81,11.81,0,0,1,1,4c.19,2.72-.21,5.29,0,7.72a17.72,17.72,0,0,0,2,6.63c1,2,2,3.78,2.93,5.53.45.87.87,1.72,1.21,2.57a12.41,12.41,0,0,1,.69,2.55,15.72,15.72,0,0,1,0,4.59,11.53,11.53,0,0,1-2.33,5.85,5,5,0,0,1-.66.7,3.18,3.18,0,0,1-.53.45c-.3.22-.46.32-.46.32a11,11,0,0,0,1.57-1.53,11.72,11.72,0,0,0,2.21-5.81,16.12,16.12,0,0,0-.07-4.53,13.1,13.1,0,0,0-.7-2.49,27.81,27.81,0,0,0-1.22-2.54c-.9-1.73-2-3.52-3-5.52a18.18,18.18,0,0,1-2-6.74c-.19-2.49.19-5.07,0-7.72a11.48,11.48,0,0,0-.94-3.91,22.89,22.89,0,0,0-2.12-3.65c-.81-1.2-1.67-2.4-2.42-3.72a11,11,0,0,1-1.51-4.35c-.37-3.22,1.51-6.22,1-9.39a11,11,0,0,0-1.91-4.4c-.91-1.38-2-2.69-2.88-4.17a29.16,29.16,0,0,1-3.33-9.92c-.66-3.48-1.12-7.07-2.43-10.47a19,19,0,0,0-2.56-4.79,12,12,0,0,0-4.13-3.53l.37-.21c0,.11,0,.22,0,.33-.21,1.88-.56,3.73-.78,5.56A31.64,31.64,0,0,0,410,365c.05.9.1,1.84.23,2.69a17.5,17.5,0,0,0,.89,2.51,46,46,0,0,1,1.92,5.05,25.16,25.16,0,0,1,.87,5.24c.18,1.73.37,3.45.54,5.15.37,3.39.6,6.77,2,9.71.67,1.46,1.57,2.81,2.23,4.29a12.43,12.43,0,0,1,1,4.64c.16,3.11-.26,6.14.56,8.9s2.57,5,3.44,7.64.53,5.35.13,7.75-.81,4.78-.3,6.93,2,3.74,2.93,5.46a7.44,7.44,0,0,1,1,2.69,24.6,24.6,0,0,1,.15,2.64,8.27,8.27,0,0,0,.33,2.34,4.29,4.29,0,0,0,1.24,1.7,11,11,0,0,0,3.14,1.8,14.35,14.35,0,0,0,2.58.72,10.12,10.12,0,0,0,1.63.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.14,358a2.29,2.29,0,0,1,.07.25l.18.72c.15.64.33,1.59.63,2.79s1,2.55,1.65,4.22a59.19,59.19,0,0,1,1.88,5.72c.6,2.15,1.13,4.54,1.69,7.09a29.6,29.6,0,0,0,2.53,7.88c.65,1.31,1.39,2.64,2,4.09a18.56,18.56,0,0,1,1.13,4.63,95.29,95.29,0,0,0,1.68,9.75L430,423.75c1.4,5.71,2.67,10.86,3.73,15.2s1.88,7.79,2.47,10.25c.27,1.18.49,2.12.65,2.8l.15.73a1.15,1.15,0,0,1,0,.25.91.91,0,0,1-.09-.24l-.21-.72c-.18-.67-.42-1.6-.74-2.77-.63-2.45-1.52-5.93-2.63-10.21s-2.39-9.47-3.83-15.17-2.9-12-4.49-18.64a90.8,90.8,0,0,1-1.68-9.79,18.83,18.83,0,0,0-1.09-4.51c-.56-1.42-1.29-2.74-1.94-4.06a30.16,30.16,0,0,1-2.52-8c-.54-2.57-1.05-4.95-1.62-7.09s-1.19-4.06-1.8-5.72-1.28-3-1.57-4.27-.42-2.17-.55-2.82l-.12-.73A1,1,0,0,1,412.14,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.62,453c-5.25-3.16-6.7-12.66-4.47-18.36s6.09-10.89,6.72-17c.48-4.67-1-9.49.09-14.06,1.51-6.16,7.56-10.91,7.53-17.26,0-3.56-2-6.92-1.85-10.48.23-4.36,3.6-7.8,5.69-11.64,3.21-5.86,3.46-12.82,4.58-19.41s3.68-13.64,9.55-16.85c.83,5.61,2.28,9.45,1.77,17-.18,2.72-3.37,7.92-3.84,13.89-.28,3.57-.47,7.14-.71,10.71s-.48,7-1.74,10.26c-1,2.49-2.52,4.74-3.24,7.31-1.37,4.83.36,10.09-.75,15-.93,4.15-3.83,7.7-4.44,11.92-.86,5.91,2.94,12.08.94,17.72-1,2.79-3.3,5-4,7.92-.52,2.24,0,4.62-.46,6.87-.76,3.63-7.7,6.42-11.4,6.17",
    style: {
      fill: "#4e7662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,333.51a1.54,1.54,0,0,1,0,.32l-.12.92c-.13.81-.27,2-.55,3.53s-1.11,3.28-1.76,5.37-1.36,4.49-2,7.19-1.13,5.68-1.68,8.89a37.33,37.33,0,0,1-2.75,10c-.75,1.67-1.59,3.35-2.22,5.14a23.37,23.37,0,0,0-1.14,5.68,112.67,112.67,0,0,1-1.61,12.24c-1.66,8.29-3.24,16.18-4.67,23.37s-2.88,13.61-4,19-2.1,9.76-2.75,12.82q-.49,2.24-.78,3.48c-.09.38-.16.68-.21.91a2.59,2.59,0,0,1-.09.3,1.2,1.2,0,0,1,0-.31c.05-.24.1-.54.17-.92l.68-3.5,2.59-12.86c1.12-5.43,2.44-11.89,3.92-19.06s3-15.08,4.63-23.36a116.77,116.77,0,0,0,1.61-12.2,24.28,24.28,0,0,1,1.18-5.8c.65-1.82,1.5-3.51,2.25-5.17a37.5,37.5,0,0,0,2.77-9.93c.56-3.2,1.1-6.19,1.74-8.89a74.68,74.68,0,0,1,2.05-7.2c.68-2.1,1.51-3.82,1.84-5.33s.48-2.7.64-3.5c.07-.38.13-.68.18-.91S462,333.51,462,333.51Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.8424b6fea98efe41c2dca6e72ddd84da.svg";
export { ForwardRef as ReactComponent };